import React from "react";
import { Form, Flex, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { HeaderApp } from "../../shared";
import type { Company } from "../types";
import { useCreateCompany } from "../hooks/userCreateCompany";
import openNotification from "../../../utils/openNotification";
import CompanyForm from "./CompanyForm";

const NewCompany: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { mutate: createCompanyMutation, isPending } = useCreateCompany();

  const handleFinish = (values: Company) => {
    createCompanyMutation(values, {
      onSuccess: () => {
        navigate("/empresa/select");
      },
      onError: (error) => {
        openNotification("error", "Error", error.message);
      },
    });
  };

  return (
    <Flex vertical style={{ background: token.colorBgLayout }}>
      <HeaderApp sectionName="Nueva Empresa" showBack backPath="/empresa/dashboard" />

      <Flex
        vertical
        gap={28}
        style={{
          maxWidth: 680,
          width: "100%",
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <CompanyForm
          form={form}
          onFinish={handleFinish}
          isPending={isPending}
          buttonText="Guardar Empresa"
          formId="new-company-form"
        />
      </Flex>
    </Flex>
  );
};

export default NewCompany;
